// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"68":"356ffb63","363":"e11c074f","672":"a2dd523a","934":"c797fb09","961":"2c7c2750","986":"41ed2411","994":"22ded54e"}[chunkId] + ".css";
};